import * as React from "react";
import { Img } from "../../../Img";
import { Heading } from "../../../Heading";
export const CardWithIconTextCard = (props) => (React.createElement("div", { className: "card-with-icon-text-card", style: { backgroundColor: props.cardColor } },
    React.createElement("div", { className: "card-with-icon-text-card__icon-wrapper" },
        React.createElement(Img, { src: props.iconUrl, alt: props.iconAlt })),
    React.createElement("div", { className: "card-with-icon-text-card__text-wrapper" },
        React.createElement(Heading, { design: "h5-lp" }, props.title),
        React.createElement("div", { className: "card-with-icon-text-card__subtitle", dangerouslySetInnerHTML: { __html: props.text } }))));
